import { Card } from 'antd';
import { useEffect, useMemo, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import ContentList from '../components/ContentList';
import PublishedList from '../components/PublishedList';

const parseTabFromSearch = (search) => {
  const tab = new URLSearchParams(search || '').get('tab');
  return tab === 'published' ? 'published' : 'raw';
};

const ContentManagement = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const activeTab = useMemo(() => parseTabFromSearch(location.search), [location.search]);
  const [mountedTabs, setMountedTabs] = useState(() => ({
    raw: activeTab === 'raw',
    published: activeTab === 'published',
  }));

  // 确保 URL 始终携带 tab，便于刷新/分享链接
  useEffect(() => {
    const params = new URLSearchParams(location.search || '');
    const tab = params.get('tab');
    if (tab !== 'raw' && tab !== 'published') {
      params.set('tab', 'raw');
      navigate({ pathname: location.pathname, search: params.toString() }, { replace: true });
    }
  }, [location.pathname, location.search, navigate]);

  // 懒挂载：首次切换到某个 tab 时才挂载对应列表，之后切换保留内部筛选/分页/勾选状态
  useEffect(() => {
    setMountedTabs((prev) => ({ ...prev, [activeTab]: true }));
  }, [activeTab]);

  return (
    <div className="page-shell">
      {mountedTabs.raw && (
        <div style={{ display: activeTab === 'raw' ? 'flex' : 'none', flex: 1, minHeight: 0, flexDirection: 'column' }}>
          <Card className="page-card" bodyStyle={{ padding: 0 }}>
            <ContentList />
          </Card>
        </div>
      )}

      {mountedTabs.published && (
        <div style={{ display: activeTab === 'published' ? 'flex' : 'none', flex: 1, minHeight: 0, flexDirection: 'column' }}>
          <Card className="page-card" bodyStyle={{ padding: 0 }}>
            <PublishedList />
          </Card>
        </div>
      )}
    </div>
  );
};

export default ContentManagement;

